import Helpers from '../modules/Helpers'

/**
 * Check if browser is IE 9
 * 
 * @return {Boolean}
 */
const isBrowserIE9 = () => {
    const htmlTag = document.getElementsByTagName('html')[0]

    return new Helpers(htmlTag).hasClass('ie9')
}

export default isBrowserIE9
